import { createSlice } from "@reduxjs/toolkit";
import { addChargingDevicesAPI } from "../../actions/chargingDevice/addChargingDevices";

const initialState = {
  addChargingDevice: {},
  loading: false,
  error: { code: "", message: "" },
};

const addChargingDevicesSlice = createSlice({
  name: "addChargingDevices",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addChargingDevicesAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addChargingDevicesAPI.fulfilled, (state, action) => {
        state.addChargingDevice = action.payload.data;
        state.loading = false;
      })
      .addCase(addChargingDevicesAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addChargingDevicesSlice.actions;
export default addChargingDevicesSlice.reducer;
